import useAnytimePricePresentation from 'hooks/Offers/useAnytimePricePresentation'

export function useHideAnytimePrices(
  offerType?: App.OfferType,
  metadataHidePricing?: boolean,
  productType?: App.ProductType,
  filters?: App.OfferListFilters,
  accommodationPropertyId?: string,
): boolean {
  const { hidePrice } = useAnytimePricePresentation({
    offerType,
    productType,
    metadataHidePricing,
    filters,
    accommodationPropertyId,
  })

  return hidePrice
}

export default useHideAnytimePrices
